export default __webpack_public_path__ + "static/media/reforestation.c770351f.png";